import LoadingFill from '@Components/generics/LoadingFill'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth'

const SignInPage = () => {
  const router = useRouter()

  const [isPendingRedirect, setIsPendingRedirect] = useState(false)
  const [doRedirect, setDoRedirect] = useState(false)

  const uiConfig = {
    signInSuccessUrl: router.query?.r ?? '/',
    signInOptions: [
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccessWithAuthResult: (authResult, redirectUrl) => {
        setDoRedirect(true)
      },
    },
  }

  useEffect(() => {
    if (doRedirect) {
      router.push(router.query?.r ?? '/')
    }
    // eslint-disable-next-line
  }, [doRedirect])

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      sx={{ height: '100%' }}
      suppressHydrationWarning={true}
    >
      <Typography variant="h5" sx={{ mb: 1 }}>
        {isPendingRedirect ? 'Signing in' : 'Sign in'}
      </Typography>
      {isPendingRedirect && <LoadingFill height="200px" />}
      <StyledFirebaseAuth
        uiCallback={(ui) => setIsPendingRedirect(ui.isPendingRedirect())}
        uiConfig={uiConfig}
        firebaseAuth={firebase.apps.length ? firebase.auth() : null}
      />
    </Box>
  )
}

export default SignInPage
